<template>
  <div class="sarpa-popup rescuer-popup">
    <div class="popup-header" :style="{ background: headerGradient }">
      <div class="popup-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l5 2.18V11c0 3.5-2.33 6.79-5 7.93C9.33 17.79 7 14.5 7 11V7.18L12 5z"/>
        </svg>
      </div>
      <div class="popup-header-text">
        <div class="popup-entity-name">{{ data.name || 'Rescuer' }}</div>
        <div class="popup-entity-sub" style="display:flex;align-items:center;gap:5px;">
          <span class="status-pill" :style="{ background: statusPillBg }">{{ statusLabel }}</span>
        </div>
      </div>
    </div>

    <div class="popup-body">
      <div class="popup-row" v-if="data.district">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>
        <span>{{ data.district }}</span>
      </div>
      <div class="popup-row" v-if="data.phone">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
        <span>{{ data.phone }}</span>
      </div>
      <div class="popup-stats-row">
        <div class="popup-mini-stat">
          <div class="mini-stat-val">{{ data.completedRescues || data.rescueCount || 0 }}</div>
          <div class="mini-stat-label">Completed</div>
        </div>
        <div class="popup-mini-stat">
          <div class="mini-stat-val">{{ data.assignedCases || data.pendingCount || 0 }}</div>
          <div class="mini-stat-label">Assigned</div>
        </div>
        <div class="popup-mini-stat">
          <div class="mini-stat-val">{{ data.rating ? data.rating.toFixed(1) : '-' }}</div>
          <div class="mini-stat-label">Rating</div>
        </div>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn primary rescuer-btn" @click="viewProfile">
        View Profile
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { getRescuerColor } from '../constants/statusColors';

export default {
  name: 'RescuerPopup',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    statusLabel() {
      let s = 'offline';
      if (typeof this.data.status === 'string') s = this.data.status.toLowerCase();
      else if (typeof this.data.availability === 'string') s = this.data.availability.toLowerCase();
      else if (this.data.is_rescuer_Available === true) s = 'available';
      else if (this.data.is_rescuer_Available === false) s = 'busy';

      if (s.includes('available')) return 'Available';
      if (s.includes('busy'))      return 'Busy';
      return 'Offline';
    },
    headerGradient() {
      let s = 'offline';
      if (typeof this.data.status === 'string') s = this.data.status.toLowerCase();
      else if (typeof this.data.availability === 'string') s = this.data.availability.toLowerCase();
      else if (this.data.is_rescuer_Available === true) s = 'available';
      else if (this.data.is_rescuer_Available === false) s = 'busy';

      const c = getRescuerColor(s);
      return `linear-gradient(135deg, ${c} 0%, ${c}cc 100%)`;
    },
    statusPillBg() {
      return 'rgba(255,255,255,0.22)';
    },
  },
  methods: {
    viewProfile() {
      if (this.$router && this.data._id) {
        this.$router.push({ name: 'viewRescuerDetails', query: { id: this.data._id } });
      }
    },
  },
};
</script>

<style>
.rescuer-popup .status-pill {
  font-size: 9.5px;
  font-family: poppinsmedium, sans-serif;
  color: #fff;
  padding: 2px 8px;
  border-radius: 10px;
}
.popup-stats-row {
  display: flex;
  gap: 0;
  margin-top: 6px;
  border-top: 1px solid #f3f4f6;
  padding-top: 8px;
}
.popup-mini-stat {
  flex: 1;
  text-align: center;
  border-right: 1px solid #f3f4f6;
}
.popup-mini-stat:last-child { border-right: none; }
.mini-stat-val {
  font-family: poppinsmedium, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}
.mini-stat-label {
  font-family: poppinsregular, sans-serif;
  font-size: 10px;
  color: #9ca3af;
}
.rescuer-popup .rescuer-btn {
  background: linear-gradient(135deg, #27AE60 0%, #2ECC71 100%);
}
</style>
